export const APPLICATION_STATUS = {
  ALL: "ALL",
  PREQUAL: "PREQUAL",
  NEW: "NEW",
  REVIEW: "REVIEW",
  VIEWED: "VIEWED",
  REOPEN: "REOPEN",
  ACCEPT: "ACCEPT",
  REJECT: "REJECT",
  QR_READY: "QR_READY",
} as const;

export const DASHBOARD_STATUS = {
  [APPLICATION_STATUS.ALL]: "All",
  [APPLICATION_STATUS.PREQUAL]: "Has Not Started",
  [APPLICATION_STATUS.NEW]: "Incomplete",
  [APPLICATION_STATUS.REVIEW]: "Completed",
  [APPLICATION_STATUS.VIEWED]: "Pending Review",
  [APPLICATION_STATUS.REOPEN]: "Reopened",
  [APPLICATION_STATUS.ACCEPT]: "Accepted",
  [APPLICATION_STATUS.REJECT]: "Declined",
  [APPLICATION_STATUS.QR_READY]: "QR Ready",
} as const;

export const NO_INPUT_PROVIDED = "DID NOT PROVIDE";
